import { RadioGroupItemProps } from '@radix-ui/react-radio-group'
import cn from 'classnames'
import { Checkbox } from '../checkbox'
import { CheckboxProps } from '../checkbox/Checkbox.types'
import { RadioButton } from '../radio-button'
import { Typography } from '../typography'
import styles from './SelectionField.module.css'
import { SelectionFieldProps } from './SelectionField.types'

export function SelectionField({
  label,
  supportingText,
  id,
  disabled,
  className,
  select,
  variant = 'transparent',
  ...rest
}: SelectionFieldProps) {
  const wrapperClasses = cn(
    styles.wrapper,
    className,
    {
      [styles.outlined]: variant === 'outlined',
      [styles.disabled]: disabled,
    },
  )

  return (
    <label htmlFor={id} className={wrapperClasses}>
      {select === 'checkbox'
        ? (
            <Checkbox className={cn(styles.control, className)} disabled={disabled} id={id} {...(rest as CheckboxProps)} />
          )
        : (
            <RadioButton
              className={cn(styles.control, className)}
              disabled={disabled}
              id={id}
              aria-label={typeof label === 'string' ? label : undefined}
              {...(rest as RadioGroupItemProps)}
            />
          )}

      <div className={styles.texts}>
        {label && (
          <Typography variant="body-m-regular-tight">
            {label}
          </Typography>
        )}
        {supportingText && (
          <Typography variant="body-s-regular-tight" className={styles.supportingText}>
            {supportingText}
          </Typography>
        )}
      </div>
    </label>
  )
}

export default SelectionField
